import { useAuth } from '@/contexts/AuthContext';

export default function Onboarding() {
    const { agent, refreshAgent, logout } = useAuth();

    const status = agent?.request_status ?? (agent?.is_approved ? 'approved' : 'pending');

    return (
        <div className="min-h-screen flex items-center justify-center p-6">
            <div className="w-full max-w-lg rounded-2xl border p-6">
                <h1 className="text-xl font-bold">تکمیل فعال‌سازی</h1>

                {status === 'rejected' ? (
                    <p className="mt-3 text-sm text-red-600">
                        درخواست شما رد شده است. لطفاً با پشتیبانی تماس بگیرید.
                    </p>
                ) : (
                    <p className="mt-3 text-sm text-zinc-600">
                        درخواست شما ثبت شده و تا زمانی که تایید نشود، امکان استفاده از پنل وجود ندارد.
                    </p>
                )}

                <div className="mt-4 flex gap-2">
                    <button className="px-4 py-2 rounded-lg border" onClick={() => refreshAgent()}>
                        بررسی دوباره وضعیت
                    </button>

                    <button className="px-4 py-2 rounded-lg bg-zinc-900 text-white" onClick={logout}>
                        خروج
                    </button>
                </div>
            </div>
        </div>
    );
}
